import styled from 'styled-components';
import { spacing, colors, smallShadow, easing, fonts } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Card } from './Card';
import { CardProps } from './types';

const StyledCard = styled(Card)`
  ${smallShadow}
  align-items: center;
  background: ${colors.backgroundPrimary};
  border-radius: ${spacing.half};
  border: 1px solid transparent;
  color: ${colors.textPrimary};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: ${fonts.sansSerif};
  height: ${pxToRem(180)};
  justify-content: center;
  padding: ${spacing.plusHalf};
  position: relative;
  transition: all 120ms ${easing.entrance};

  &:hover {
    background: ${colors.backgroundPrimaryHover};
    border: 1px solid ${colors.borderEmphasis};
  }
`;

export const AppCard = ({ children, onClick }: CardProps) => {
  return <StyledCard onClick={onClick}>{children}</StyledCard>;
};
